import React, { Component } from 'react'
import { connect } from 'react-redux'
import './landing.css'
import StartCard from './Start'
import Features from './Features'
import FooterCTA from './FooterCTA'
import GlobalFooter from '../../nav/GlobalFooter'
import GlobalNav from '../../nav/GlobalNav'

const mapStateToProps = (state, ownProps) => ({
  me: state.me,
  viewParams: ownProps.viewParams,
})

class Landing extends Component {
  constructor() {
    super()
    this.state = {
      zoomed: null,
      scrolled: true,
    }

    this.setState = this.setState.bind(this)
  }

  render() {
    const { me, dispatch, viewParams } = this.props

    return (
      <div className="landing">
        <div className="background-top"></div>
        <GlobalNav />
        <div className="content">
          <StartCard />
          <div className="customer-logos">
            <img src="https://statics.streamable.com/static/landing/logos-grey-min.png"></img>
          </div>
          <Features />
          <div className="stats-pane">
            <h2>Streamable is loved by over 50 million users and customers from 122 countries</h2>
            <div className="testimonials">
              <div className="testimonial">
                <img className="photo" src="https://statics.streamable.com/static/landing/danny.jpg"></img>
                <div className="testimonial-content">
                  <img className="stars" src="https://statics.streamable.com/static/landing/stars.png"></img>
                  <div className="testimonial-text">
                    “I love it when a web tool provides a simple service seamlessly. @streamable is a super clean #video publishing tool. Host a vid with no surrounding noise but the logo. Embed tool as well. Great place to host and share a video.”
                  </div>
                  <div className="testimonial-name">
                    <b>Danny McLellan, VP Events</b> &mdash; Twitter
                  </div>
                </div>
              </div>
              <div className="testimonial">
                <img className="photo" src="https://statics.streamable.com/static/landing/uponia.png"></img>
                <div className="testimonial-content">
                  <img className="stars" src="https://statics.streamable.com/static/landing/stars.png"></img>
                  <div className="testimonial-text">
                  “Shoutout to @streamable for being so good at converting videos, else I would not have any awesome plays of the game to share with my server members!”
                  </div>
                  <div className="testimonial-name">
                    <b>Uponia Gaming</b> &mdash; Twitch.tv
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="footer">
          <div className="background" />
          <FooterCTA />
          <GlobalFooter />
        </div>
      </div>
    )
  }
}

export default connect(mapStateToProps)(Landing)
